export default __webpack_public_path__ + "static/media/pinewood.189ff6d3.PNG";